import { combineReducers } from 'redux'
import auth from './auth'
import notification from './auth/notificationSlice'
import setting from './auth/settingSlice'
import report from './auth/reportSlice'
import network from './auth/networkSlice'
import locale from './locale/localeSlice'
import admin from './admin'
import user from './user'
import inspector from './inspector'

const rootReducer = asyncReducers => (state, action) => {
    const combinedReducer = combineReducers({
        auth,
        notification,
        setting,
        report,
        network,
        locale,
        admin,
        user,
        inspector,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
